// extracted by mini-css-extract-plugin
export default {"restictWidth":"single-cube_pieces_sadlib-ad_restictWidth"};